
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[exchange]/[ticker]/commodity-exposure",
      function () {
        return require("private-next-pages/s/[exchange]/[ticker]/commodity-exposure/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[exchange]/[ticker]/commodity-exposure"])
      });
    }
  